module.exports = __webpack_public_path__ + "img/Dog.05633440.svg";